// extracted by mini-css-extract-plugin
export default {"fragmentsWrapper":"styles_fragmentsWrapper__w1Q2r","circle":"styles_circle__WWZWI","left":"styles_left__kqvfz","right":"styles_right__eS9Zn","background":"styles_background__WdMDT"};